import { useQuery } from '@tanstack/react-query';
import Api from '@/services/api';
import type { BaseContext } from '@/types';
import { ROSA_QUERY_KEYS } from './query-keys';

type GetEquipmentsResponse = {
	id: string;
	name: string;
	description: string;
};

async function getEquipments(params: BaseContext): Promise<GetEquipmentsResponse[]> {
	const url = `ergonomic-tool/rosa/equipments`;
	const { data } = await Api.get<GetEquipmentsResponse[]>(url, { params });
	return data;
}

export const useGetEquipments = (params: BaseContext) => {
	const data = useQuery([ROSA_QUERY_KEYS.GET_EQUIPMENTS], () => getEquipments(params));
	return data;
};
